<template>
  <v-layout>
    <v-flex xs12>
      <child-toolbar :title="title" :buttons="buttons" />
      <bt-realization-expense-form @input="change" :value="expense" v-if="loaded" ref="form" />
      <h2 v-else>Loading...</h2>
    </v-flex>
  </v-layout>
</template>

<script>
import Vuex from 'vuex'
import BtRealizationExpenseForm from './BtRealizationExpenseForm'
import ChildToolbar from '@/components/ChildToolbar'

const btRealizationStore = Vuex.createNamespacedHelpers('BusinessTripRealization/Realization')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  name: 'BtRealizationExpenseNew',
  components: {
    BtRealizationExpenseForm,
    ChildToolbar
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    backRoute: {
      type: [String, Object],
      required: false,
      default: null
    }
  },
  data () {
    return {
      title: 'New Expense Realization',
      buttons: [
        { tooltip: 'Close',
          icon: 'close',
          handler: this.close
        },
        { tooltip: 'Save',
          icon: 'save',
          handler: this.save,
          disabled: !this.formValid
        }
      ],
      expense: {},
      loaded: false,
      formValid: false
    }
  },
  computed: {
    expenses () {
      return this.value.expenses
    }
  },
  watch: {
    formValid (newValue) {
      this.buttons.find(x => x.handler === this.save).disabled = !newValue
    }
  },
  methods: {
    ...btRealizationStore.mapActions({
      getNewRealizationExpense: 'getNewRealizationExpense'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    loadResources () {
      const self = this
      self.getNewRealizationExpense({vueinstance: self})
        .then(res => {
          self.expense = res
          self.expense.tripDate = Date.now()
          self.loaded = true
        })
        .catch(err => self.$error(err))
    },
    save () {
      const self = this
      delete self.expense.id
      delete self.expense.sppdReal

      self.expense.subTotal = parseFloat(self.expense.subTotal)
      self.expense.total = parseFloat(self.expense.total)
      self.expense.percentage = parseFloat(self.expense.percentage)

      self.expenses.push(self.expense)
      self.modified = false
      self.$emit('updateExpense', self.expenses)
      self.close()
    },
    change (expense) {
      this.formValid = this.$refs.form.validate()
      this.modified = true
    },
    close () {
      this.$router.replace(this.backRoute)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.loadResources())
  },
  beforeRouteLeave (to, from, next) {
    if (this.modified) {
      const yesHandler = () => {
        this.closeConfirmation()
        next()
      }

      const noHandler = () => {
        this.closeConfirmation()
      }

      this.showConfirmation({
        message: 'Are you sure?',
        title: 'This Business Trip Expense Realization will not saved.',
        buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]
      })
    } else {
      next()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bt-realization/BtRealizationExpenseNew.vue